import { api } from './apiClient';

export const fetchUserList = async (page = 1, pageSize = 10, searchtext = '', startDate = '', endDate = '') => {
  try {
    const requestBody = {
      pagination: {
        page,
        pageSize,
        sort: { createdAt: -1 }
      },
      searchtext: searchtext || ''
    };

    // Add date filters if provided
    if (startDate && endDate) {
      requestBody.startDate = startDate;
      requestBody.endDate = endDate;
    }

    const response = await api.post('/api/v1/admin/users/list', requestBody);

    return response.data;
  } catch (error) {
    if (error.response) {
      const message = error.response.data?.message || `Server error: ${error.response.status}`;
      throw new Error(message);
    } else if (error.request) {
      throw new Error('Unable to reach the server. Please check your internet connection or try again later.');
    } else {
      throw new Error(error.message || 'An unexpected error occurred');
    }
  }
};

export const fetchUserStats = async (startDate, endDate) => {
  try {
    const requestBody = {
      startDate: startDate,
      endDate: endDate,
    };

    const response = await api.post('/api/v1/admin/users/stats', requestBody);
    return response.data;
  } catch (error) {
    if (error.response) {
      const message = error.response.data?.message || `Server error: ${error.response.status}`;
      throw new Error(message);
    } else if (error.request) {
      throw new Error('Unable to reach the server. Please check your internet connection or try again later.');
    } else {
      throw new Error(error.message || 'An unexpected error occurred');
    }
  }
};

